import { useFormik, Form, FormikProvider } from "formik";
import Model from "components/Modal";
import {
  createDocument,
  getAllData,
  updateDocumentByID,
} from "apis/customApiHandler";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { BiCloudDownload } from "react-icons/bi";
import { DownloadAggrement } from "./DownloadAggrement";
import { useState } from "react";

const ViewAgreement = ({ data, handleClick,setShowAgreement,selectedAgreement }) => {
  console.log('data--',data);
  const queryClient = useQueryClient();

  const formik = useFormik({
    initialValues: {
      registrationNumber: data?.registrationNumber || "",
      contractType: data?.contractType?._id || "",
      hub: data?.hub?._id || "",
      mechanicalCondition: data?.mechanicalCondition?._id || "620608a35b52522414b6c16d",
      // mechanicalConditionReason: data?.mechanicalConditionReason?._id || "",
      vehicleMake: data?.vehicleMake?._id || "",
      model: data?.model?._id || "",
      configuration: data?.configuration?._id || "",
      engineNumber: data?.engineNumber || "",
      chasisNumber: data?.chasisNumber || "",
      bodyType: data?.bodyType?._id || "",
      applicationType: data?.applicationType?._id || "",
      registrationYear: data?.registrationYear || "",
      vehicleCC: data?.vehicleCC || "",
      GVW: data?.GVW || "",
      fleet: data?.fleet?._id || "",
    },
    onSubmit: async (values) => {
      Object.keys(values).forEach((key) => {
        if (values[key] === "") {
          delete values[key];
        }
      });
      const result = data
        ? await updateDocumentByID("vehicle", data._id, values)
        : await createDocument("vehicle", values);
      if(result) toast.success("Successfully saved");
      queryClient.invalidateQueries("vehicles");
      handleClick();
    },

    validate: (values) => {
      const errors = {};
      if (!values.fleet) errors.fleet = "Required";
      if (!values.hub) errors.hub = "Required";
      if (!values.registrationNumber) errors.registrationNumber = "Required";
      if (!values.contractType) errors.contractType = "Required";
      // if (!values.mechanicalCondition) errors.mechanicalCondition = "Required";
      if (!values.vehicleMake) errors.vehicleMake = "Required";
      if (!values.model) errors.model = "Required";
      if (!values.configuration) errors.configuration = "Required";
      if (!values.bodyType) errors.bodyType = "Required";
      if (!values.applicationType) errors.applicationType = "Required";
      if (!values.registrationYear) errors.registrationYear = "Required";
      if (values.registrationYear && values.registrationYear.length > 4)
        errors.registrationYear = "max 4 digits is allowed";
      if (
        values.registrationYear &&
        values.registrationYear.length <= 4 &&
        /^[0-9]+$/.test(values.registrationYear) === false
      )
        errors.registrationYear = "only digits is allowed";
      if (!values.vehicleCC) errors.vehicleCC = "Required";
      if (values.vehicleCC && values.vehicleCC.length > 5)
        errors.vehicleCC = "max 5 digits is allowed";
      if (
        values.vehicleCC &&
        values.vehicleCC.length <= 5 &&
        /^[0-9]+$/.test(values.vehicleCC) === false
      )
        errors.vehicleCC = "only digits is allowed";
      if (!values.GVW) errors.GVW = "Required";
      if (values.GVW && values.GVW.length > 4)
        errors.GVW = "max 4 digits is allowed";
      if (
        values.GVW &&
        values.GVW.length <= 4 &&
        /^[0-9]+$/.test(values.GVW) === false
      )
        errors.GVW = "only digits is allowed";
      if (!values.fleet) errors.fleet = "Required";
      return errors;
    },
  });

  const fetchFile = async (url) => {
    console.log('url--',url);
    const originalImage = url;
    const image = await fetch(originalImage);

    //Split image name
    const nameSplit = originalImage.split("/");
    const duplicateName = nameSplit.pop();

    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = "" + duplicateName + "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  console.log('data--',data);
 
  return (
    <Model
      handleClick={handleClick}
      title={data ? "Update Agreement" : "Upload Agreement"}
      className="max-w-2xl"
    >

        <DownloadAggrement data={data?.agreement} selectedAgreement={selectedAgreement}/>

    </Model>
  );
};

export default ViewAgreement;

